import React from 'react';
import styles from './UIGameEndReturnToStats.module.scss';
import { T } from '@colonist/ui';
import { UIGameButton } from '../../../common/UIGameButton/index.ts';
import { useGameStore } from '../../../store/GameStoreContext.ts';
import clsx from 'clsx';
export const UIGameEndReturnToStats = ({ text, className })=>{
    const onClickStatsOrReplay = useGameStore((state)=>{
        var _state_gameEnd_endControls;
        return (_state_gameEnd_endControls = state.gameEnd.endControls) === null || _state_gameEnd_endControls === void 0 ? void 0 : _state_gameEnd_endControls.onClickStatsOrReplay;
    });
    const isStatsVisible = useGameStore((state)=>state.gameEnd.isVisible);
    if (!onClickStatsOrReplay) return null;
    if (isStatsVisible) return null;
    return /*#__PURE__*/ React.createElement(UIGameButton, {
        className: clsx(styles.button, className),
        variant: "dark",
        onClick: onClickStatsOrReplay
    }, /*#__PURE__*/ React.createElement(T, {
        id: text
    }));
};
